// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor1 from '@/game/prefabs/World/Mentors/Mentor1';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from '@/game/scenes/TilemapScenes/TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level29 extends TilemapScene {
  constructor() {
    super('Level29');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // forest_biome_9
    const forest_biome_9 = this.add.tilemap('forest-biome-9');
    forest_biome_9.addTilesetImage(
      'summer forest wang tiles',
      'summer forest wang tiles',
    );
    forest_biome_9.addTilesetImage('summer 32x32', 'summer 32x32');
    forest_biome_9.addTilesetImage('summer forest', 'summer forest');
    forest_biome_9.addTilesetImage('bonus bridge', 'bonus bridge');
    forest_biome_9.addTilesetImage(
      'summer water sparkles B',
      'summer water sparkles B 16x16',
    );

    // tilemapLayers
    const tilemapLayers = this.add.container(0, 0);

    // wang_Terrain_1
    const wang_Terrain_1 = forest_biome_9.createLayer(
      'Wang Terrain',
      ['summer forest wang tiles'],
      0,
      0,
    )!;
    tilemapLayers.add(wang_Terrain_1);

    // water_Features_1
    const water_Features_1 = forest_biome_9.createLayer(
      'Water Features',
      ['summer forest', 'summer 32x32'],
      -7,
      -6,
    )!;
    tilemapLayers.add(water_Features_1);

    // sparkles_1
    const sparkles_1 = forest_biome_9.createLayer(
      'Sparkles',
      ['summer water sparkles B'],
      0,
      0,
    )!;
    tilemapLayers.add(sparkles_1);

    // bridge
    const bridge = forest_biome_9.createLayer(
      'Bridge',
      ['bonus bridge'],
      0,
      -32,
    )!;
    tilemapLayers.add(bridge);

    // mentor1
    const mentor1 = new Mentor1(this, 42, 102);
    this.add.existing(mentor1);

    // player
    const player = new Player(this, 217, 49);
    this.add.existing(player);

    // portal
    const portal = new Portal(this, 37, 493);
    this.add.existing(portal);

    // worldNode
    const worldNode = new WorldNode(this, 194, 167);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 157, 487);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 563, 427);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 526, 238);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 667, 86);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 671, 514);
    this.add.existing(worldNode_5);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 54, 401);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 132, 271);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 252, 335);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 344, 514);
    this.add.existing(worldNode_9);

    // forestTree1
    const forestTree1 = new ForestTree1(this, 99, 30);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 11, 70);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(this, 18, 271);
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(this, 61, 323);
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(this, 13, 398);
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(this, 261, 127);
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(this, 189, 146);
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(this, 360, 114);
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(this, 303, 191);
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(this, 663, 53);
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(this, 496, 187);
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      237,
      177,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      347,
      158,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      73,
      41,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      23,
      280,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      26,
      365,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      633,
      86,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      319,
      142,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      269,
      185,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      269,
      185,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      54,
      357,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      494,
      317,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      495,
      207,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      677,
      74,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      690,
      520,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(
      this,
      253,
      324,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(
      this,
      438,
      501,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(
      this,
      108,
      607,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(
      this,
      436,
      20,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_27);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 28;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 28;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 28;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 28;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 28;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 28;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 28;
    worldNode_6.NPCId = 6;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 28;
    worldNode_7.NPCId = 7;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 28;
    worldNode_8.NPCId = 8;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 28;
    worldNode_9.NPCId = 9;

    this.mentor1 = mentor1;
    this.player = player;
    this.portal = portal;
    this.worldNode = worldNode;
    this.worldNode_1 = worldNode_1;
    this.worldNode_2 = worldNode_2;
    this.worldNode_3 = worldNode_3;
    this.worldNode_4 = worldNode_4;
    this.worldNode_5 = worldNode_5;
    this.worldNode_6 = worldNode_6;
    this.worldNode_7 = worldNode_7;
    this.worldNode_8 = worldNode_8;
    this.worldNode_9 = worldNode_9;
    this.forest_biome_9 = forest_biome_9;

    this.events.emit('scene-awake');
  }

  private mentor1!: Mentor1;
  private player!: Player;
  private portal!: Portal;
  private worldNode!: WorldNode;
  private worldNode_1!: WorldNode;
  private worldNode_2!: WorldNode;
  private worldNode_3!: WorldNode;
  private worldNode_4!: WorldNode;
  private worldNode_5!: WorldNode;
  private worldNode_6!: WorldNode;
  private worldNode_7!: WorldNode;
  private worldNode_8!: WorldNode;
  private worldNode_9!: WorldNode;
  private forest_biome_9!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.forest_biome_9,
      portal: this.portal,
      mentor: this.mentor1,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
